import { TYPES } from "./request.type";

const initState = {
  all: null,
  count: null,
};

const requestReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SELECT_ALL_REQUEST_SUCCESS:
      return {
        ...state,
        all: payload,
      };

    case TYPES.GET_COUNT_REQUEST_SUCCESS:
      return {
        ...state,
        count: payload,
      };

    default:
      return state;
  }
};

export default requestReducer;
